import { BaseComponent } from './../../../../shared/Components/base/base.component';
import { PagingService } from './../../../../shared/Services/PagingService';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ContactService } from '../../services/contactService';
import { Contact } from '../../models/contact';
import { NbToastrService } from '@nebular/theme';





@Component({
  selector: 'ngx-email.contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent extends BaseComponent implements OnInit {
  contact: Contact;
  isLoading: boolean = false;
  constructor(public service: ContactService, public route: Router, public paging: PagingService,
    private toast: NbToastrService) {
    super(route, service, paging, '');
    this.contact = {} as Contact;
  }

  ngOnInit() {
    this.service.getData('').subscribe(res => {
      this.contact = res;
    });
  }

  get isFormValid (){
return ( this.contact.address == '' &&
  this.contact.headQuarter == '' &&
  this.contact.twitterLink == '' &&
  this.contact.faceBookLink == '' &&
  this.contact.youTubeLink == '' &&
  this.contact.instagramLink == '' &&
  this.contact.email == '') ? false : true
  }

  update() {
    // this.isLoading = true;
    this.service.put(this.contact.id, this.contact).subscribe(
      (res) => {
        this.isLoading = false;
        this.toast.show('تم تحديث بيانات الاتصال بنجاح', '', { status: 'success', duration: 3000 });
      },
      (error) => {
        this.isLoading = false;
        this.toast.show('خطأ في تحديث بيانات الاتصال', '', { status: 'danger', duration: 3000 });
      },
    );
  }
}
